import { makeStyles } from "@material-ui/core/styles";

export const screenStyles = makeStyles(theme => ({

  })
)  